import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_ALL_CLIENTS',
  'GET_ARCHIVED_CLIENTS',
  'CREATE_CLIENT'
);
